import React from 'react'
import { Modal } from '@imedcl/design-system'
import { ReactComponent as Error } from '../../assets/img/Error-404.svg'

export default function ModalContent() {
  return (
    <div className='mt-8'>
      <Modal backgroundClassName='!relative'>
        <React.Fragment key='.0'>
          <div className='mb-6  flex items-center justify-center '>
            <Error width={200}></Error>
          </div>
          <div>
            <h2 className='text-center text-xl text-secondary-imed-100 mb-4'>
              <strong>
                <h2>Error 404 - Página no encontrada.</h2>
              </strong>
            </h2>
          </div>
        </React.Fragment>
      </Modal>
    </div>
  )
}
